// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2wdta","dragIcon":"Choice_dragIcon__MqqKJ","left":"Choice_left__2_fXf","input":"Choice_input__3S1yl"};